module.exports = __webpack_public_path__ + "static/6-3258269a76b27f19055d3a459c8fdea1.png";